module.exports = __webpack_public_path__ + "img/Blog1.5fd76df8.png";